import closeImg from "../../../assets/close.png";
import "./style.css";

const HeaderSimple = (props) => {
	return (
		<header className="ms-1 mt-2 header-simple">
			<div className="title">
				<h1 className="text-2xl font-bold ">{props.title}</h1>
			</div>
			<button
				type="button"
				onClick={(e) => props.handleCloseModalRegister()}
				className="react-modal-close"
			>
				<img src={closeImg} alt="Fechar" />
			</button>
		</header>
	);
};

export default HeaderSimple;
